export const STATE_CODES = {
    VIC: "VIC",
    NSW: "NSW",
    QLD: "QLD"
};
